import { render, staticRenderFns } from "./inspectItem.vue?vue&type=template&id=e9a285cc&scoped=true"
import script from "./inspectItem.vue?vue&type=script&lang=js"
export * from "./inspectItem.vue?vue&type=script&lang=js"
import style0 from "./inspectItem.vue?vue&type=style&index=0&id=e9a285cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a285cc",
  null
  
)

export default component.exports